import classNames from 'classnames';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';
import { getCardIcon } from 'util';

export default function ({ item, isLoading }) {
  const { width } = useWindowDimensions();
  const isMobile = width < 500;
  if (isLoading) return <SingleTextLoader />;

  if (!item.paymentMethodDetails) return '-';

  if (
    item.paymentMethodDetails.includes('Cash') ||
    item.paymentMethodDetails.includes('Other')
  ) {
    return (
      <p className={classNames(isMobile && 'f12')}>
        {item.paymentMethodDetails}
      </p>
    );
  }

  const [brand, last4] = item.paymentMethodDetails.split('-');
  return (
    <div className="flex-row">
      <Icon name={getCardIcon(brand)} />
      <p
        className={classNames('ml-10', isMobile && 'f12')}
      >{`**** ${last4}`}</p>
    </div>
  );
}
